import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { Sector } from "@modules/bookSectors/types";

export function useBookSectors() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createSectorModalRef = useRef<ModalRef>(null);
  const editSectorModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Sector>({
    resource: "v1/book_sector_admin",
    filters: getQueryParams(),
    sorters: { ordering: "-id" },
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,

    createSectorModalRef,
    editSectorModalRef,
    refetch,
    setSelectedRows,
    translate,

  };
}
